const defaultConfig = {
  fhirVersion: "4.0.1",
  clientId: "smart-app",
  scopes: "launch openid fhirUser patient/*.read",
  logo: "/images/hopkins-logo.png",
  supportsBatch: false,
  welcomeMessage: "Welcome, Johns Hopkins Medicine"

};

export default defaultConfig;